import { React, useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';

import moment from 'moment';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

import HoldingAndExtendHistoryInfoView from './HoldingAndExtendHistoryInfoView';
import RefundInfoView from './RefundInfoView';

import MemberShipHistoryInfoButtonImagePath from '../../../../image/MemberShipHistoryInfoButton.png';
import OrangeTrashIcon from '../../../../image/OrangeTrashIcon.png';

const MemberShipHistoryInfoView = forwardRef((props, ref) => {
  const { t } = useLanguage();
  const {
    data, 
    index, 
    size,

    firstExpiredIndex,

    modifyClick, 
    holdingClick, 
    extensionClick, 
    refundClick, 
    subscriptionCancelClick,
    deleteClick,

    onClickHoldingAndExtendButton, 
    onClickHoldingEdit,
    onClickDeleteHoldingHistory,
    onClickModifyExtend,
    onClickDeleteExtend,
    onClickRefundDelete,
    onClickDeleteExpectedUsage
  } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClicked, setIsClicked] = useState(false);
  const [buttonImage, setButtonImage] = useState(MemberShipHistoryInfoButtonImagePath);
  const [fontColor, setFontColor] = useState(theme.subText);
  const [border, setBorder] = useState(`1px solid ${theme.subBackground}`);
  const [hoverBorder, setHoverBorder] = useState(`1px solid ${theme.subBackground}`);
  const [backgroundColor, setBackgroundColor] = useState(theme.subBackground);

  const OptionBoxRef = useRef();
  const OptionButtonRef = useRef();
  const OptionEditRef = useRef();
  const OptionHoldRef = useRef();
  const OptionExtendRef = useRef();
  const OptionDeleteRef = useRef();
  const SubscriptionCancelRef = useRef();
  
  const ExpectedDeleteRef = useRef();

  useImperativeHandle(ref, () => ({
    setIsClicked: () => {
      setIsClicked(false);
    },
    getButtonRef: () => {
      return OptionButtonRef.current;
    },
    getBoxRef: () => {
      return OptionBoxRef.current;
    }
  }))

  useEffect(() => {
    if (data.isExpectedMemberShip) return;

    if (isClicked) {
      // OptionBoxRef.current.style.height = `142px`;
      // OptionBoxRef.current.style.height = `108px`;
      if (data.isSubscriptionMembership) OptionBoxRef.current.style.height = `210px`;
      else OptionBoxRef.current.style.height = `176px`;
      // OptionBoxRef.current.style.height = `176px`;
      OptionBoxRef.current.style.border = `1px solid ${theme.primary}`;
    }
    else {
      OptionBoxRef.current.style.height = `0px`;
      OptionBoxRef.current.style.border = `0px solid ${theme.primary}`;
    }
  }, [isClicked, data, theme])

  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  useEffect(() => {
    let startDate = moment(data.startDate);
    let endDate = moment(data.endDate);
    
    // 환불 데이터의 경우 //
    if (data.isRefund) {
      setFontColor(theme.subText);
      setBorder(`1px solid ${theme.buttonFill}`);
      setHoverBorder(`1px solid ${theme.primary}`);
      setBackgroundColor(theme.buttonFill);
      setButtonImage(MemberShipHistoryInfoButtonImagePath);
    }
    else if (data.isExpectedMemberShip) {
      setFontColor(theme.subText);
      setBorder(`1px solid ${theme.buttonFill}`);
      setHoverBorder(`1px solid ${theme.primary}`);
      setBackgroundColor(theme.buttonFill);
      setButtonImage(MemberShipHistoryInfoButtonImagePath);
    }
    // 사용 예정의 데이터인 경우 //
    else if (moment().isBefore(startDate)) {
      setFontColor(theme.subText);
      setBorder(`1px solid ${theme.subBackground}`);
      setHoverBorder(`1px solid ${theme.primary}`);
      setBackgroundColor(theme.subBackground);
      setButtonImage(MemberShipHistoryInfoButtonImagePath);
    }
    // 사용 기한이 끝나지 않은 경우 //
    else if (moment().isBefore(endDate)) {
      if (data.totalMax !== -1 
        && data.totalMax <= data.courseTakeCount
        && (data.lastReserveDate !== undefined && moment().startOf('day').isAfter(data.lastReserveDate))) {
        setFontColor(theme.subText);
        setBorder(`1px solid ${theme.buttonFill}`);
        setHoverBorder(`1px solid ${theme.primary}`);
        setBackgroundColor(theme.buttonFill);
        setButtonImage(MemberShipHistoryInfoButtonImagePath);
      }
      else {
        setFontColor(theme.subText);
        setBorder(`1px solid ${theme.subBackground}`);
        setHoverBorder(`1px solid ${theme.primary}`);
        setBackgroundColor(theme.subBackground);
        setButtonImage(MemberShipHistoryInfoButtonImagePath);
      }
    }
    // 예정된 기한이 지난경우 //
    else {
      setFontColor(theme.subText);
      setBorder(`1px solid ${theme.buttonFill}`);
      // setHoverBorder('1px solid #595959');
      setHoverBorder(`1px solid ${theme.primary}`);
      setBackgroundColor(theme.buttonFill);
      // setButtonImage(MemberShipHistoryInfoGrayButtonImagePath);
      setButtonImage(MemberShipHistoryInfoButtonImagePath);
    }
  }, [data, theme, isDark])

  // 구독 상태 결정 //
  function decideSubscriptionStatus() {
    if (data.subscribeStatus && !data.subscribeDeleted) return 'subscribing';
    if (moment().isBefore(moment(data.startDate))) return 'expected';
    if (data.isExpectedMemberShip) return 'waiting';
    return 'ended';
  }

  function onClickOutSide(e) {
    if (OptionBoxRef.current !== e.target
      && OptionButtonRef.current !== e.target
      && OptionEditRef.current !== e.target
      && OptionHoldRef.current !== e.target
      && OptionExtendRef.current !== e.target
      && SubscriptionCancelRef.current !== e.target
      && OptionDeleteRef.current !== e.target) {
      setIsClicked(false);
    }
  }

  // 마우스 호버링
  function mouseOver() {
    OptionButtonRef.current.style.opacity = 1;
  }

  // 마우스 호버링
  function mouseLeave() {
    OptionButtonRef.current.style.opacity = 0;
  }

  // 링코페이 여부 확인 //
  function isLinkoPay() {
    if (!data.merchantUid) return false;
    const indicator = data.merchantUid.split('-')[2];
    return indicator === '1' || indicator === '2';
  }

  // 결제 금액 정리 //
  function decideTotalPriceView() {
    if (data.selectedPaymentOptions === undefined || data.selectedPaymentOptions.length === 0) {
      if (data.cardPrice === 0 && data.cashPrice === 0) return t('memberDetail.payFree');
      else if (data.cardPrice === 0) return data.cashPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCash');
      else if (data.cashPrice === 0) return data.cardPrice.toLocaleString('ko-KR') + ' - ' + (isLinkoPay() ? t('memberDetail.payLinkoPay') : t('memberDetail.payCard'));
      else return (parseInt(data.cashPrice) + parseInt(data.cardPrice)).toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
    else {
      const allSame = data.selectedPaymentOptions.every(item => item.name === data.selectedPaymentOptions[0].name);
      const totalPrice = data.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);

      const paymentNameMap = { '카드': isLinkoPay() ? t('memberDetail.payLinkoPay') : t('memberDetail.payCard'), '현금': t('memberDetail.payCash'), '포인트': t('memberDetail.payPoint'), '링코페이': t('memberDetail.payLinkoPay') };
      if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + (paymentNameMap[data.selectedPaymentOptions[0].name] || data.selectedPaymentOptions[0].name);
      else return totalPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
  }

  // 남은일수에 맞춰 텍스트 정리 //
  function remainDaysView() {
    if (data.isRefund) return t('memberDetail.statusRefund');
    else if (data.isExpectedMemberShip) {
      const days = moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days');
      if (days > 0) return days + t('memberDetail.daysSuffix');
      if (days === 0) return 'D-Day';
      return t('memberDetail.statusExpired');
    }
    else if (data.totalMax === data.courseTakeCount
      && (data.lastReserveDate !== undefined && (moment().startOf('day').isAfter(data.lastReserveDate)))) return t('memberDetail.statusExpired');
    else if (moment().isBefore(data.startDate)) return t('memberDetail.statusScheduled');
    else if (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days') > 0) {
      return moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days') + t('memberDetail.daysSuffix');
    }
    else if (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days') === 0) {
      return 'D-Day'
    }

    return t('memberDetail.statusExpired');
  }

  // 수강 횟수 표시 //
  function decideUseTotalMax() {
    if (data.totalMax === -1) return data.courseTakeCount + '/∞';
    else return data.courseTakeCount + '/' + data.totalMax;
  }
  

  // 몸체 눌렀을때 켜지기 //
  function onClickBody(e) {
    if (e.target === OptionButtonRef.current || OptionBoxRef.current.contains(e.target)) return;

    modifyClick(index);
  }

  return (
    <TopLevelWrapper>
      { (firstExpiredIndex !== -1 && firstExpiredIndex === index) && <ExpiredDivisionLine/> }
      <MemberShipComponent 
        $isDark={isDark}
        zIndex={60 + size - index}
        border={border} 
        hoverBorder={hoverBorder} 
        backgroundColor={backgroundColor} 
        isPartial={data.isRefund || data.historyData.length > 0}
        onMouseOver={mouseOver} 
        onMouseLeave={mouseLeave} 
        onClick={onClickBody}>
      <Table>
        <Body>
          <Tr style={{ width: '251px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '251px', gap: '4px' }}>
                {
                  (data.isSubscriptionMembership || data.isExpectedMemberShip) &&
                  <SubscriptionBox statusType={decideSubscriptionStatus()}>
                    <SubscriptionText>
                      {decideSubscriptionStatus() === 'subscribing' ? t('memberDetail.statusSubscribing')
                        : decideSubscriptionStatus() === 'expected' ? t('memberDetail.statusScheduled')
                        : decideSubscriptionStatus() === 'waiting' ? t('memberDetail.statusWaiting')
                        : t('memberDetail.statusSubscriptionEnded')}
                    </SubscriptionText>
                  </SubscriptionBox>
                }
                <Text color={fontColor}>{data.memberShipName}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '202px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '197px' }}>
                <Text color={fontColor}>
                  {moment(data.startDate).format(t('memberDetail.membershipEditModal.dateFormat'))} - {moment(data.endDate).format(t('memberDetail.membershipEditModal.dateFormat'))}
                </Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '164px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '160px' }}>
                <Text color={fontColor}>{decideTotalPriceView()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '190px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '180px' }}>
                <Text color={fontColor}>{data.notReceivedPrice.toLocaleString('ko-KR')}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '70px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '66px' }}>
                <Text color={fontColor}>{remainDaysView()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '83px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '53px' }}>
                <Text color={fontColor}>{decideUseTotalMax()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr>
              {
                data.isExpectedMemberShip ?
                  <Td>
                    <IconWrapper ref={OptionButtonRef} onClick={() => onClickDeleteExpectedUsage(data)}>
                      <Icon ref={OptionBoxRef} src={OrangeTrashIcon} />
                    </IconWrapper>
                  </Td>
                  :
                  <Td>
                    <OptionButton ref={OptionButtonRef} src={buttonImage} onClick={() => setIsClicked(!isClicked)} />
                    <OptionWrapper ref={OptionBoxRef}>
                      <Option ref={OptionEditRef} onMouseDown={() => modifyClick(index)}>{t('memberDetail.btnModify')}</Option>
                      <Option ref={OptionHoldRef} onMouseDown={() => holdingClick(index)}>{t('memberDetail.btnHolding')}</Option>
                      <Option ref={OptionExtendRef} onMouseDown={() => extensionClick(index)}>{t('memberDetail.btnExtension')}</Option>
                      <Option ref={OptionExtendRef} onMouseDown={() => refundClick(index)}>{t('memberDetail.btnRefund')}</Option>
                      { data.isSubscriptionMembership && <Option ref={SubscriptionCancelRef} onMouseDown={() => subscriptionCancelClick(index)}>{t('memberDetail.btnCancelSubscription')}</Option> }
                      <Option ref={OptionDeleteRef} onMouseDown={() => deleteClick(index)}>{t('memberDetail.btnDelete')}</Option>
                    </OptionWrapper>
                  </Td>
            }
          </Tr>
        </Body>
      </Table>
      </MemberShipComponent>
      <SubBackgroundCover zIndex={60 + size - index - 1}/>
      {
        data.isRefund &&
        <ExpertComponentWrapper zIndex={data.historyData.length + 1}>
          <RefundInfoView
            data={data}
            onClickDeleteRefund={onClickRefundDelete}
            onClickModifyRefund={() => refundClick(index)}/>
        </ExpertComponentWrapper>
      }
      {
        data.historyData.map((innerData, index) => (
          <ExpertComponentWrapper key={'MembershipHistory-' + index} zIndex={data.historyData.length - index}>
            <HoldingAndExtendHistoryInfoView 
              data={innerData} 
              onClickHoldingAndExtendButton={onClickHoldingAndExtendButton} 
              onClickHoldingEdit={onClickHoldingEdit}
              onClickDeleteHoldingHistory={onClickDeleteHoldingHistory}
              onClickModifyExtend={onClickModifyExtend}
              onClickDeleteExtend={onClickDeleteExtend} />
          </ExpertComponentWrapper>
        ))
      }
    </TopLevelWrapper>
  )
});

export default MemberShipHistoryInfoView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1018px;

  // height: 
  // display: flex;
  // flex-direction: column;

  // justify-content: center;
  // align-items: flex-start;

  // width: 1018px;
  // height: 50px;

  // box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);

  // border: ${props => props.border};
  // border-radius: 30px;
  // background-color: ${props => props.backgroundColor};
    
  // transition: all 0.3s ease-in-out;

  // :hover {
  //   cursor: pointer;
  //   border: ${props => props.hoverBorder};
  // }
`;

const MemberShipComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 1018px;
  height: 50px;

  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};

  z-index: ${props => props.zIndex};

  border: ${props => props.border};
  border-radius: ${props => props.isPartial ? '30px 10px 0px 30px' : '30px'};
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: ${props => props.hoverBorder};
  }
`;

const ExpiredDivisionLine = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 37px 0px;

  width: 1018px;
  height: 1px;

  background-color: ${props => props.theme.line};
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;
    
  // margin-left: 28px;
  margin-left: 15px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;
`;

const SubscriptionBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 5px;
  margin-top: 2px;

  min-width: 30px;
  min-height: 18px;

  border-radius: 5px;
  background-color: ${props =>
    props.statusType === 'subscribing' ? props.theme.primary
    : props.statusType === 'ended' ? props.theme.primary
    : props.statusType === 'expected' ? props.theme.pointYellow
    : props.theme.subKey};
`;

const SubscriptionText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.theme.subBackground};

  margin: -2px 0 0 0;
  padding: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const OptionButton = styled.img`
  opacity: 0;
    
  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  overflow: hidden;
    
  z-index: 10;

  margin-top: 40px;
  margin-left: -20px;

  border-radius: 8px;

  transition: all 0.2s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: column;;

  justify-content: center;
  align-items: center;

  width: 58px;
  height: 38px;

  margin: 0 0 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.primary};
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.primary};
  }
`;

const SubBackgroundCover = styled.div`
  position: relative;

  width: 1018px;
  height: 50px;

  margin-top: -50px;

  z-index: ${props => props.zIndex};

  border-radius: 30px;
  background-color: ${props => props.theme.background};
`;

const ExpertComponentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  z-index: ${props => props.zIndex};
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  opacity: 0;

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Icon = styled.img`
  width: 100%;
  height: 100%;
`;
